export const faqItems = [
  {
    question: "瓜田秘闻社的内容是从哪里来的？",
    answer:
      "我们主要整理公开平台上已经流传的讨论、报道与网友投稿，再补充时间线和背景信息。所有内容都会标注大致的来源脉络，方便你自行判断可信度。",
  },
  {
    question: "为什么文章里的人物都用“某顶流”“某小花”这样的代称？",
    answer:
      "使用匿名代称是我们的内容原则之一。一方面给讨论留出空间，另一方面也避免对具体个人造成不必要的困扰。真实的瓜不在于名字，而在于事情本身的逻辑。",
  },
  {
    question: "你们会发布没有根据的爆料吗？",
    answer:
      "不会。我们只整理已经在公开渠道流传的信息，并且要求自己不做二次加工式的添油加醋。如果一条消息只有孤证，我们会明确标注“网传”，并提示读者谨慎看待。",
  },
  {
    question: "发现文章里有说错的地方，怎么反馈？",
    answer:
      "非常欢迎纠错。你可以通过“联系我们”页面的留言表单，或者直接发邮件给我们。核实之后我们会尽快修正，并在文末补充更正说明。",
  },
  {
    question: "内容会更新吗？热点过去之后还能看到吗？",
    answer:
      "会更新。快讯类内容会随着事件发展追加进展；专题类文章则会在关键节点做补充。历史文章我们不会删除，方便你回看整件事的走势。",
  },
  {
    question: "每天大概更新多少内容？",
    answer:
      "快讯类平均每天更新四十条左右，深扒解读每周三到五篇。我们不追求数量堆砌，宁可少发几条，也要保证每条都有实际信息量。",
  },
  {
    question: "可以投稿或者提供线索吗？",
    answer:
      "可以。欢迎通过联系页面的表单提交线索，请尽量提供可公开查证的信息来源。我们会核实之后再决定是否整理成文。",
  },
  {
    question: "内容涉及商业推广吗？",
    answer:
      "目前站内所有内容均为编辑整理，不包含付费推广。如果未来出现合作内容，我们会在文首明确标注，绝不与常规内容混排。",
  },
];